module.exports = __webpack_public_path__ + "media/images/checked-thumbnail-inactive-3f4d5a3a8305d3e7bf6aa459fdf8c3f7.png";